import React, { Dispatch, SetStateAction, createContext } from 'react'
import { CaseType, SessionType } from '../types'

type caseDialogStateType = {
  show?: boolean | undefined;
  clientId?: number | undefined;
}

type manageCaseDialogStateType = {
  show?: boolean | undefined;
  caseId?: number | undefined;
}

type sessionDialogStateType = {
  show?: boolean | undefined;
  clientId?: number | undefined;
  caseId?: number | undefined;
}

type ClientMenuStatusDialogType = {
  show?: boolean | undefined;
  clientId?: number | undefined;
}


type EditSessionDialogType = {
  show: boolean;
  currentSession: SessionType;
  sessionCase: CaseType;
}

interface DialogsContext {
  editSessionDialog: EditSessionDialogType;
  setEditSessionDialog: Dispatch<SetStateAction<EditSessionDialogType>>;
  showAddClientDialog: boolean;
  setShowAddClientDialog: Dispatch<SetStateAction<boolean>>

  caseDialogState: caseDialogStateType;
  setCaseDialogState: Dispatch<SetStateAction<caseDialogStateType>>
  showCaseDialog: ({ show, clientId }: caseDialogStateType) => void;

  manageCaseDialogState: manageCaseDialogStateType;
  setManageCaseDialogState: Dispatch<SetStateAction<caseDialogStateType>>
  showManageCaseDialog: ({ show, caseId }: manageCaseDialogStateType) => void;

  sessionDialogSate: sessionDialogStateType;
  setSessionDialogSate: Dispatch<SetStateAction<sessionDialogStateType>>
  showSessionDialog: ({ show, clientId, caseId }: sessionDialogStateType) => void;
  showPrivacyWaiverDialog: boolean;
  setShowPrivacyWaiverDialog: Dispatch<SetStateAction<boolean>>;
  showHealingWaiverDialog: boolean;
  setShowHealingWaiverDialog: Dispatch<SetStateAction<boolean>>
  showPublicNotice: boolean;
  setShowPublicNotice: Dispatch<SetStateAction<boolean>>;
  /** The case currently open in the reviewer workspace, or null when closed. */
  reviewWorkspaceCase: CaseType | null;
  setReviewWorkspaceCase: Dispatch<SetStateAction<CaseType | null>>;
  clientMenuDialog: ClientMenuStatusDialogType;
  setClientMenuDialog: Dispatch<SetStateAction<ClientMenuStatusDialogType>>;
  showCohortSelectorDialog: boolean;
  setShowCohortSelectorDialog: Dispatch<SetStateAction<boolean>>;
  showCaseTypesDialog: boolean;
  setShowCaseTypesDialog: Dispatch<SetStateAction<boolean>>;
}

export const DialogsContext = createContext<DialogsContext>(undefined as any)

interface Props {
  children: React.ReactNode
}

export const DialogsProvider: React.FC<Props> = ({ children }) => {
  const [editSessionDialog, setEditSessionDialog] = React.useState({
    show: false,
    currentSession: {} as SessionType,
    sessionCase: {} as CaseType,
  });

  const [showAddClientDialog, setShowAddClientDialog] = React.useState(false);
  const [ showCohortSelectorDialog, setShowCohortSelectorDialog ] = React.useState(false);
  const [showCaseTypesDialog, setShowCaseTypesDialog] = React.useState(false);

  const [sessionDialogSate, setSessionDialogSate] = React.useState<sessionDialogStateType>({
    show: false,
    clientId: undefined,
    caseId: undefined
  });
  const [caseDialogState, setCaseDialogState] = React.useState<caseDialogStateType>({
    show: false,
    clientId: undefined,
  });

  const [manageCaseDialogState, setManageCaseDialogState] = React.useState<caseDialogStateType>({
    show: false,
    clientId: undefined,
  });


  const showCaseDialog = ({ show, clientId }: caseDialogStateType) => {
    if (clientId && clientId !== undefined) {
      setCaseDialogState((prev) => ({ ...prev, show: show === undefined ? true : show, clientId: clientId }));
    } else {
      setCaseDialogState((prev) => ({ ...prev, show: show === undefined ? true : show }));
    }
  }

  const showManageCaseDialog = ({ show, caseId }: manageCaseDialogStateType) => {
    if (caseId && caseId !== undefined) {
      setManageCaseDialogState((prev) => ({ ...prev, show: show === undefined ? true : show, caseId: caseId }));
    } else {
      setManageCaseDialogState((prev) => ({ ...prev, show: show === undefined ? true : show }));
    }
  }

  const isUndefined = (value: any) => {
    if (value !== undefined) {
      return false;
    }
    return true;
  }

  const showSessionDialog = ({ show, clientId, caseId }: sessionDialogStateType) => {
    const data = {
      ...(isUndefined(show) ? {} : { show: show }),
      ...(isUndefined(clientId) ? {} : { clientId: clientId }),
      ...(isUndefined(caseId) ? {} : { caseId: caseId })
    }
    setSessionDialogSate((prev) => ({ ...prev, ...data }));
  }

  const [showPrivacyWaiverDialog, setShowPrivacyWaiverDialog] = React.useState(false);
  const [showHealingWaiverDialog, setShowHealingWaiverDialog] = React.useState(false);
  const [showPublicNotice, setShowPublicNotice] = React.useState(false);
  const [reviewWorkspaceCase, setReviewWorkspaceCase] = React.useState<CaseType | null>(null);

  const [clientMenuDialog, setClientMenuDialog] = React.useState<ClientMenuStatusDialogType>({
    show: false,
    clientId: undefined,
  });


  const values = {
    editSessionDialog,
    setEditSessionDialog,
    sessionDialogSate,
    setSessionDialogSate,
    caseDialogState,
    setCaseDialogState,
    showAddClientDialog: showAddClientDialog,
    setShowAddClientDialog,
    showCaseDialog,
    manageCaseDialogState,
    setManageCaseDialogState,
    showManageCaseDialog,
    showSessionDialog,
    showPrivacyWaiverDialog,
    setShowPrivacyWaiverDialog,
    showHealingWaiverDialog,
    setShowHealingWaiverDialog,
    showPublicNotice,
    setShowPublicNotice,
    reviewWorkspaceCase,
    setReviewWorkspaceCase,
    clientMenuDialog,
    setClientMenuDialog,
  showCohortSelectorDialog,
  setShowCohortSelectorDialog,
    showCaseTypesDialog,
    setShowCaseTypesDialog,
  }

  return <DialogsContext.Provider value={values}>{children}</DialogsContext.Provider>
}
